import { invoke } from '@tauri-apps/api/core';
import { isTauriRuntime } from './Environment';

export const DEBUG_LOG_FILE_PATH = 'C:\\Users\\Public\\Documents\\ESTsoft\\CreatorTemp\\jrpgui\\runtime-debug.log';

let writeQueue = Promise.resolve();

export function appendDebugLogLine(line: string) {
  if (!isTauriRuntime()) return;

  writeQueue = writeQueue
    .then(async () => {
      await invoke('append_debug_log', { line });
    })
    .catch(() => {});
}
